import { cn } from "@design-system/utils";
import * as React from "react";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "text-shape-neutral-outlined-foreground-default placeholder:text-shape-neutral-outlined-foreground-muted bg-shape-neutral-outlined-background border-shape-neutral-outlined-border-emphasised flex field-sizing-content min-h-24 w-full min-w-0 rounded-md border px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:ring-ring-default focus-visible:ring-[3px]",
        "aria-invalid:border-shape-critical-outlined-border-emphasised",
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
